exports = module.exports = require("../../../apps/support-agent/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/*css classes*/\n.ddContainer{\n\twidth:100%;\n\tposition:absolute;\n\tbottom:0;\n\ttop: 0;\n\toverflow:auto;\n}", ""]);
